import { NULL_ADDRESS } from 'src/base/constants';
import { ethers } from 'ethers';
import { Dispatch, useState } from 'react';
import { Address } from 'src/base/types';
import { Contract } from "ethers";

// TODO: can we make this DRYer by not duplicating useMintingFunctions ?

interface UseLootMintingFunctionsParams {
	pieceId: number;
	mintCount: number;
	setShowLoadingOverLay: Dispatch<boolean>; // TODO: 
	setCustomLoadingMessage: Dispatch<string>;
	priceToUse: string;
	raycOrZaycAddress: Address;
	selectedVault: Address;
	tokenIdToUse: number;
	tokenIdsToUse: number[];
	tierToUse: string;
	lootContract: Contract; // todo: make this generic
}

export default function useLootMintingFunctions({ pieceId, mintCount, setShowLoadingOverLay, setCustomLoadingMessage, priceToUse, raycOrZaycAddress, selectedVault, tokenIdToUse, tokenIdsToUse, tierToUse, lootContract } : UseLootMintingFunctionsParams) {
	const [ doneMinting, setDoneMinting ] = useState(false);
	async function mintSingle() {
		// this assumes the wallet is already connected
		const msgValueWei = priceToUse && ethers.parseEther( priceToUse );
		// pieceId is the tokenId of the piece
		const tokenAddress = raycOrZaycAddress; // the 'mint pass address';
		const tokenId = tokenIdToUse;
		// if the token address is null, then don't pass the vault address even if there is a selected vault
		const vaultAddress = ( selectedVault && tokenAddress !== NULL_ADDRESS ) ? selectedVault : NULL_ADDRESS;

		try {
			setCustomLoadingMessage( 'Awaiting transaction approval' );
			setShowLoadingOverLay( true );

			const tx = await lootContract.mint( pieceId, tokenAddress, tokenId, vaultAddress, { value: msgValueWei });

			setCustomLoadingMessage( 'Confirming transaction' );
			await tx.wait();
			// location.reload();
		} catch ( e ) {
			if ( e.reason && e.reason.includes( 'Invalid delegate-vault pairing' ) ) {
				alert( `Error: Invalid delegate-vault pairing. This means your hot wallet is not a delegate for the ${tierToUse} in your cold wallet (vault address)` );
			} else {
				console.error( e );
			}
			throw e;
		} finally {
			setShowLoadingOverLay( false );
		}
	}
	async function mintMultiple() {
		const msgValueWei = priceToUse && (ethers.parseEther( priceToUse ) as any) * BigInt(mintCount);
		// TODO: handle a mixture
		const ids = Array.from({ length: mintCount }, () => pieceId );
		const tokenAddresses = Array.from({ length: mintCount }, () => raycOrZaycAddress ); // the 'mint pass address';
		const tokenIds = tierToUse === 'public' ? Array.from({ length: mintCount }, () => 0 ) : tokenIdsToUse.slice( 0, mintCount );
		const vaults = Array.from({ length: mintCount }, () => ( selectedVault && raycOrZaycAddress !== NULL_ADDRESS ) ? selectedVault : NULL_ADDRESS );

		try {
			setCustomLoadingMessage( 'Awaiting transaction approval' );
			setShowLoadingOverLay( true );

			const tx = await lootContract.mintMultiple( ids, tokenAddresses, tokenIds, vaults, { value: msgValueWei });

			setCustomLoadingMessage( 'Confirming transaction' );
			await tx.wait();
			// location.reload();
		} catch ( e ) {
			if ( e.reason && e.reason.includes( 'Invalid delegate-vault pairing' ) ) {
				alert( `Error: Invalid delegate-vault pairing. This means your hot wallet is not a delegate for the ${tierToUse} in your cold wallet (vault address)` );
			} else {
				console.error( e );
			}
			throw e;
		} finally {
			setShowLoadingOverLay( false );
		}
	}

	async function onClickMint () {
		if ( mintCount === 0 ) return;
		if ( mintCount === 1 ) {
			await mintSingle();
		} else {
			await mintMultiple();
		}
		setDoneMinting( true );
	}

	return ({ onClickMint, doneMinting });
}
